import { motion, useReducedMotion } from "motion/react";
import { projects } from "../data";
import { Reveal, Section, TagList } from "./ui";

const CORNERS = ["leaf", "leaf-tr", "leaf-bl"] as const;

const SPAN = [
  "lg:col-span-7",
  "lg:col-span-5",
  "lg:col-span-5",
  "lg:col-span-7",
] as const;

export function Projects() {
  const reduce = useReducedMotion();

  return (
    <Section
      id="work"
      title="Selected work"
      intro="Three projects where I did the whole arc — problem, design, build, and the debugging that follows."
    >
      <div className="grid gap-6 lg:grid-cols-12">
        {projects.map((project, index) => (
          <Reveal
            key={project.title}
            delay={index * 0.1}
            className={(index < SPAN.length ? SPAN[index] : undefined) ?? "lg:col-span-6"}
          >
            <motion.article
              whileHover={reduce ? undefined : { y: -6 }}
              transition={{ type: "spring", stiffness: 320, damping: 28 }}
              className={`glass ${CORNERS[index % CORNERS.length] ?? "leaf"} group flex h-full flex-col p-7 sm:p-9`}
            >
              <div className="flex items-baseline justify-between gap-4">
                <h3 className="text-display max-w-[22ch] text-[1.55rem] leading-tight text-porcelain">
                  {project.title}
                </h3>
                <span className="shrink-0 text-[0.78rem] text-faint">{project.year}</span>
              </div>

              <p className="mt-3 text-display-italic text-[1.05rem] text-blush/90">{project.blurb}</p>

              <p className="mt-5 max-w-[56ch] flex-1 leading-relaxed text-mist">
                {project.description}
              </p>

              <TagList items={project.tags} className="mt-7" />
            </motion.article>
          </Reveal>
        ))}
      </div>
    </Section>
  );
}
